module.exports = __webpack_public_path__ + "img/flower-tulip.361887c3.svg";